import { Dialog } from "@mui/material";
import { CustomListType, Notice } from "../types/types";
import styled from "styled-components";
import theme from "../theme";
import ReactQuill from "react-quill";
import useGetNoticeDetail from "../hooks/useGetNoticeDetail";
import React, { useEffect, useRef, useState } from "react";
import {
  ArrowUpDownButton,
  NoticeDetail,
  XButton,
} from "../assets/icons/icons";
import Spinner from "./spinner";
import { usePutReadingCheck } from "../hooks/usePutReadingCheck";
import userStorage from "../utils/userStorage";
import { DotLoader } from "./dotLoader";
import { useNavigate } from "react-router-dom";
import { formatDate } from "../utils/util";

const modules = {
  toolbar: false,
};

const NewNoticeCarousel: React.FC<{
  openNewNoticeCarousel: boolean;
  setOpenNewNoticeCarousel: any;
  newNoticeData: CustomListType<Notice[]>; // 유저가 읽지 않은 공지들
  isLoading: boolean;
}> = (props) => {
  const {
    openNewNoticeCarousel,
    setOpenNewNoticeCarousel,
    newNoticeData,
  } = props;

  const user = userStorage.get();
  const navigate = useNavigate();
  const [indexCounter, setIndexCounter] = useState(
    newNoticeData.total_items
  );
  const [totalIndex] = useState(newNoticeData.total_items);
  const [id, setId] = useState(newNoticeData.list[0].idx);
  // const [activeX, setActiveX] = useState(false);
  const divEl = useRef<HTMLDivElement>(null);
  const [activeLeft, setActiveLeft] = useState(false);
  const [activeRight, setActiveRight] = useState(false);
  const [startCoord, setStartCoord] = useState({
    x: 0,
    y: 0,
  });
  const [endCoord, setEndCoord] = useState({
    x: 0,
    y: 0,
  });

  const { data: NoticeDetailData, isLoading: NoticeDetailDataIsLoading } =
    useGetNoticeDetail({
      idx: Number(id),
      isAdmin: user?.permission?.auth_notice === "Y",
    });

  const { mutate: patchReadingCheck } = usePutReadingCheck({
    idx: String(id),
  });

  useEffect(() => {
    newNoticeData.list.findIndex((el) => el.idx === id);
  });

  // 왼쪽 화살표 클릭
  const handleClickLeft = () => {
    // 첫번째 값인지 확인
    if (totalIndex && indexCounter && totalIndex - indexCounter === 0) {
      return;
    } else {
      setIndexCounter((prev) => prev && prev + 1);
      setActiveRight(true);
    }
    if (
      newNoticeData.total_items &&
      totalIndex &&
      indexCounter &&
      totalIndex - indexCounter === 1
    ) {
      setActiveLeft(false);
    }
    // setActiveX(false);
  };

  // 오른쪽 화살표 클릭
  const handleClickRight = () => {
    // 마지막 값인지 확인
    if (
      newNoticeData.total_items &&
      totalIndex &&
      indexCounter &&
      totalIndex - indexCounter === newNoticeData.total_items - 1
    ) {
      return;
    } else {
      setIndexCounter((prev) => prev && prev - 1);
      setActiveLeft(true);
    }
    //
    if (
      newNoticeData.total_items &&
      totalIndex &&
      indexCounter &&
      totalIndex - indexCounter === newNoticeData.total_items - 2
    ) {
      // setActiveX(true);
      setActiveRight(false);
    }
  };

  // 확인 버튼 클릭
  const handleClickCheck = () => {
    patchReadingCheck();

    if (
      newNoticeData &&
      totalIndex &&
      indexCounter &&
      totalIndex - indexCounter == newNoticeData.list.length - 1
    ) {
      setIndexCounter((prev) => prev && prev + 1);
    }
    if (totalIndex && indexCounter && totalIndex - indexCounter == 0) {
      setIndexCounter(
        (prev) => prev
        // && prev - 1
      );
    }
  };

  // 자세히 보기 클릭
  const handleClickDetail = () => {
    navigate(`/notice/${id}`, {
      state: { from: "home" },
    });
  };

  useEffect(() => {
    // 새 공지가 1개인 경우확인하기
    if (newNoticeData.total_items === 1) {
      // setActiveX(true);
      setActiveLeft(false);
      setActiveRight(false);
    } else {
      setActiveLeft(false);
      setActiveRight(true);
    }
  }, [newNoticeData]);

  useEffect(() => {
    setActiveLeft(false);
    setActiveRight(false);

    // 확인 버튼 클릭 후 왼쪽 버튼 확인
    if (totalIndex && indexCounter && totalIndex - indexCounter != 0) {
      setActiveLeft(true);
    } else {
      setActiveLeft(false);
    }

    // 확인 버튼 클릭 후 오른쪽 버튼 확인
    if (
      totalIndex &&
      indexCounter &&
      totalIndex - indexCounter + 1 == newNoticeData.total_items
    ) {
      setActiveRight(false);
    } else {
      setActiveRight(true);
    }
  }, [newNoticeData, totalIndex, indexCounter, id]);

  useEffect(() => {
    if (
      newNoticeData &&
      newNoticeData.list &&
      totalIndex &&
      indexCounter
    ) {
      let index = totalIndex - indexCounter;
      if (index == -1) {
        // 더이상 데이터 없음
        return;
      } else {
        setId(newNoticeData.list[index].idx);
      }
    }
  }, [totalIndex, indexCounter, newNoticeData]);

  useEffect(() => {
    if (Math.abs(startCoord.x - endCoord.x) > 50) {
      if (startCoord.x - endCoord.x > 0) {
        handleClickRight();
        setStartCoord({ x: 0, y: 0 });
        setEndCoord({ x: 0, y: 0 });
      } else if (startCoord.x - endCoord.x < 0) {
        handleClickLeft();
        setStartCoord({ x: 0, y: 0 });
        setEndCoord({ x: 0, y: 0 });
      }
    } else {
      return;
    }
  }, [endCoord]);

  return (
    <>
      <Dialog
        open={openNewNoticeCarousel}
        // onClose={() => setOpenNewNoticeCarousel(false)} // 배경클릭시 닫힘
        PaperProps={{
          sx: {
            minWidth: { xs: "320px", sm: "600px", md: "700px" },
            maxWidth: { xs: "320px", sm: "600px", md: "700px" },
            height: { xs: "550px", sm: "800px", md: "800px" },
            minHeight: { xs: "550px", sm: "800px", md: "800px" },
            pt: { xs: "20px", sm: "42px", md: "42px" },
            pb: { xs: "20px", sm: "47px", md: "47px" },
            pl: "20px",
            pr: "20px",
            borderRadius: "20px",
            overflow: "hidden",
            position: "relative",
          },
        }}
      >
        {/* 닫기 버튼 */}
        {
          // 마지막 컨텐츠에만  x버튼 활성화하고싶을때 주석 지우기
          // activeX &&
          <XButtonContainer
            onClick={() => setOpenNewNoticeCarousel(false)}
          >
            <XButton
              width={window.innerWidth > 600 ? "40" : "30"}
              height={window.innerWidth > 600 ? "40" : "30"}
            />
          </XButtonContainer>
        }

        {
          <CarouselContainer ref={divEl}>
            {NoticeDetailDataIsLoading && (
              <SpinnerContainer>
                <Spinner />
              </SpinnerContainer>
            )}
            {NoticeDetailData && (
              <NoticeListWrapper>
                {/* 확인 버튼 */}
                <NewNoticeCheckButton
                  onClick={() => {
                    handleClickCheck();
                  }}
                >
                  확인
                </NewNoticeCheckButton>

                {/* 공지 제목 */}
                <NoticeTitle>{NoticeDetailData.title}</NoticeTitle>
                {/* 공지 날짜 */}
                <NoticeDate>
                  {newNoticeData &&
                    formatDate(
                      NoticeDetailData.create_dt,
                      "yyyy-MM-dd HH:mm:ss"
                    )}
                </NoticeDate>
                {NoticeDetailDataIsLoading && <Spinner />}
                {!NoticeDetailDataIsLoading && NoticeDetailData && (
                  <DetailWrapper>
                    <Detail
                      theme="snow"
                      modules={modules}
                      readOnly={true}
                      value={NoticeDetailData?.contents}
                    />
                  </DetailWrapper>
                )}
              </NoticeListWrapper>
            )}
          </CarouselContainer>
        }

        {activeLeft && (
          <LeftButton
            disabled={NoticeDetailDataIsLoading}
            onClick={handleClickLeft}
          >
            <ArrowUpDownButton />
          </LeftButton>
        )}
        {activeRight && (
          <RightButton
            disabled={NoticeDetailDataIsLoading}
            onClick={handleClickRight}
          >
            <ArrowUpDownButton />
          </RightButton>
        )}
        {/* 자세히 보기 버튼 */}
        <DetailButton onClick={() => handleClickDetail()}>
          <p style={{ marginRight: "5px" }}>자세히 보기</p>
          <NoticeDetail
            width={window.innerWidth < 600 ? "40px" : "23px"}
            height={window.innerWidth < 600 ? "40px" : "23px"}
            fill={
              window.innerWidth < 600
                ? theme.color.neutral_500
                : theme.color.black
            }
          />
        </DetailButton>
        {
          <CounterContainer>
            {/* 페이징 : 숫자 */}
            {NoticeDetailData &&
              `${
                newNoticeData.list.findIndex((el) => el.idx === id) + 1
              } / ${newNoticeData.total_items}`}

            {/* 로딩 */}
            {NoticeDetailDataIsLoading && <DotLoader />}
          </CounterContainer>
        }
      </Dialog>
    </>
  );
};
const XButtonContainer = styled.div`
  position: absolute;
  top: 10px;
  right: 10px;
  color: ${theme.color.neutral_500};
  z-index: 10;
`;
const CarouselContainer = styled.div`
  width: 100%;
  display: flex;
  flex-grow: 1;
`;

const NoticeListWrapper = styled.div`
  width: 100%;
  flex: 1;
  flex-shrink: 0;
  background: ${theme.color.white};
  border-radius: 10px;
  padding: 10px;
  padding-left: 60px;
  padding-right: 60px;
  display: flex;
  flex-direction: column;
  gap: 5px;
  margin-bottom: 10px;

  @media (max-width: 600px) {
    padding-left: 20px;
    padding-right: 20px;
    height: 460px;
  }
`;

const NewNoticeCheckButton = styled.button`
  position: absolute;
  bottom: 20px;
  right: 56px;
  background-color: ${theme.statusColor.MAIN};
  color: ${theme.color.white};
  border: none;
  border-radius: 8px;
  height: 40px;
  width: 56px;
  font-weight: 700;
  font-size: 14px;
  line-height: 19px;
  cursor: pointer;
  &:hover {
    background-color: ${theme.statusColor.MAIN_HOVER};
  }

  @media (max-width: 600px) {
    right: 15px;
    height: 40px;
    width: 56px;
    bottom: 15px;
  }
`;

const NoticeTitle = styled.h1`
  font-size: 18px;
  line-height: 25px;
  color: ${theme.color.neutral_600};
  padding-top: 5px;
  padding-bottom: 5px;
  font-weight: bold;

  @media (max-width: 600px) {
    font-size: 15px;
    line-height: 17px;
  }
`;

const NoticeDate = styled.p`
  font-weight: 400;
  font-size: 12px;
  line-height: 19px;
  color: ${theme.color.neutral_500};
`;

const DetailWrapper = styled.div`
  background-color: transparent;
  flex: 1;
  border-radius: 10px;
  z-index: 11;
`;
const Detail = styled(ReactQuill)`
  width: 100%;
  border-top: 1px solid ${theme.color.neutral_200};
  border-bottom: 1px solid ${theme.color.neutral_200};
  padding-top: 30px;
  overflow-y: auto;
  margin-bottom: 32px;
  @media (max-width: 600px) {
    padding-top: 20px;
    margin-bottom: 20px;
  }
  .ql-editor strong {
    font-weight: 700;
  }
  .ql-editor em {
    font-style: italic;
  }
  .ql-editor u {
    text-decoration: underline;
  }
  .ql-editor {
    background-color: transparent;
    border: none;
    border-radius: 10px;
    max-height: 520px;
    min-height: 520px;

    @media (max-width: 600px) {
      padding-left: 5px;
      padding-right: 5px;
      max-height: 300px;
      min-height: 300px;
    }
  }
  .ql-container {
    border: none;
  }
`;

const LeftButton = styled.button`
  position: absolute;
  border: none;
  background-color: transparent;
  transform: rotate(270deg);
  left: -5px;

  :disabled {
    opacity: 0.5;
    div {
      cursor: default;
      :hover {
        scale: 100%;
      }
    }
  }
  @media (max-width: 600px) {
    top: 50%;
    left: -10px;
  }
  @media (min-width: 600px) {
    bottom: 20px;
  }
`;
const RightButton = styled.button`
  position: absolute;
  border: none;
  background-color: transparent;
  transform: rotate(90deg);
  right: -5px;
  /* top: 50%; */

  :disabled {
    opacity: 0.5;
    div {
      cursor: default;
      :hover {
        scale: 100%;
      }
    }
  }

  @media (max-width: 600px) {
    top: 50%;
    right: -10px;
  }
  @media (min-width: 600px) {
    bottom: 20px;
  }
`;
const CounterContainer = styled.div`
  display: flex;
  gap: 20px;
  position: absolute;
  bottom: 30px;
  left: 50%;
  transform: translateX(-50%);

  @media (max-width: 600px) {
    font-size: 13px;
  }
`;

// const NoticeCountDot = styled.div<{ isActive: boolean }>`
//   width: 10px;
//   height: 10px;
//   border-radius: 50%;
//   background-color: ${({ isActive }) =>
//     isActive
//       ? `${theme.color.neutral_500}`
//       : `${theme.color.neutral_300}`};
// `;

const DetailButton = styled.button`
  position: absolute;
  bottom: 30px;
  left: 56px;
  display: flex;
  align-items: center;
  justify-content: end;
  border: none;
  background-color: transparent;
  font-size: 14px;
  font-weight: bold;
  transition: 0.2s;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }

  @media (max-width: 600px) {
    p {
      display: none;
    }
    left: 20px;
    bottom: 15px;
    text-decoration: underline;
    color: ${theme.color.neutral_700};
  }

  @media (min-width: 600px) {
    svg {
      display: none;
    }
  }
`;

const SpinnerContainer = styled.div`
  width: 100%;
  height: 100%;
  flex-grow: 1;
`;
export default NewNoticeCarousel;
